export const buildLoopedHomeBanners = (banners) => {
	if (banners.length <= 1) {
		return banners.map((banner) => ({
			banner,
			key: banner.id,
		}));
	}

	const firstBanner = banners[0];

	return [
		...banners.map((banner) => ({
			banner,
			key: banner.id,
		})),
		{
			banner: firstBanner,
			key: `${firstBanner.id}-loop-tail`,
		},
	];
};
